import type { SVGProps } from "react";
const SvgCarryOnBaggageNotIncluded = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 32 32"
    {...props}
  >
    <defs>
      <linearGradient
        id="carryOnBaggageNotIncluded_svg__d"
        x1={21}
        x2={21}
        y1={27.504}
        y2={28.034}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#141414" />
        <stop offset={1} stopColor="#141414" stopOpacity={0} />
      </linearGradient>
      <linearGradient
        id="carryOnBaggageNotIncluded_svg__e"
        x1={10.999}
        x2={10.999}
        y1={27.504}
        y2={28.034}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#141414" />
        <stop offset={1} stopColor="#141414" stopOpacity={0} />
      </linearGradient>
      <linearGradient
        id="carryOnBaggageNotIncluded_svg__g"
        x1={15.997}
        x2={15.997}
        y1={14.271}
        y2={28.566}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#ACACAC" stopOpacity={0.5} />
        <stop offset={1} stopColor="#A9A9A9" />
      </linearGradient>
      <linearGradient
        id="carryOnBaggageNotIncluded_svg__h"
        x1={15.066}
        x2={20.973}
        y1={16.815}
        y2={16.815}
        gradientUnits="userSpaceOnUse"
      >
        <stop offset={0.102} stopColor="#fff" />
        <stop offset={0.115} stopColor="#E3E3E3" />
        <stop offset={0.204} stopColor="#fff" />
        <stop offset={0.214} stopColor="#E3E3E3" />
        <stop offset={0.233} stopColor="#E3E3E3" />
        <stop offset={0.446} stopColor="#fff" stopOpacity={0.973} />
        <stop offset={0.455} stopColor="#E3E3E3" />
        <stop offset={0.549} stopColor="#fff" />
        <stop offset={0.56} stopColor="#E3E3E3" />
        <stop offset={1} stopColor="#E3E3E3" />
      </linearGradient>
      <radialGradient
        id="carryOnBaggageNotIncluded_svg__b"
        cx={0}
        cy={0}
        r={1}
        gradientTransform="translate(11 28.122)scale(1.25)"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset={0.33} stopColor="#1F1F1F" />
        <stop offset={0.462} stopColor="#4D4D4D" />
        <stop offset={0.759} stopColor="#4D4D4D" />
        <stop offset={0.829} stopColor="#3B3B3B" />
        <stop offset={1} stopColor="#141414" />
      </radialGradient>
      <radialGradient
        id="carryOnBaggageNotIncluded_svg__c"
        cx={0}
        cy={0}
        r={1}
        gradientTransform="translate(21 28.122)scale(1.25)"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset={0.33} stopColor="#1F1F1F" />
        <stop offset={0.462} stopColor="#4D4D4D" />
        <stop offset={0.759} stopColor="#4D4D4D" />
        <stop offset={0.829} stopColor="#3B3B3B" />
        <stop offset={1} stopColor="#141414" />
      </radialGradient>
      <clipPath
        id="carryOnBaggageNotIncluded_svg__f"
        transform="translate(-7.273 -9.163)"
      >
        <path d="M21.723 10.163H10.271c-1.103 0-1.998.95-1.998 2.123V26c0 1.173.895 2.123 1.998 2.123h11.452c1.104 0 1.998-.95 1.998-2.123V12.286c0-1.172-.895-2.123-1.998-2.123" />
      </clipPath>
      <filter
        id="carryOnBaggageNotIncluded_svg__a"
        width={19.645}
        height={4.617}
        x={6.174}
        y={27.063}
        filterUnits="userSpaceOnUse"
      >
        <feGaussianBlur stdDeviation={1} />
      </filter>
    </defs>
    <g filter="url(#carryOnBaggageNotIncluded_svg__a)" opacity={0.5}>
      <ellipse cx={15.996} cy={29.372} fill="#000" rx={7.822} ry={0.309} />
    </g>
    <path
      fill="url(#carryOnBaggageNotIncluded_svg__b)"
      d="M11 29.372a1.25 1.25 0 1 0 0-2.5 1.25 1.25 0 0 0 0 2.5"
    />
    <path
      fill="url(#carryOnBaggageNotIncluded_svg__c)"
      d="M21 29.372a1.25 1.25 0 1 0 0-2.5 1.25 1.25 0 0 0 0 2.5"
    />
    <path
      fill="url(#carryOnBaggageNotIncluded_svg__d)"
      d="M21 26.872c.69 0 1.25.56 1.25 1.25h-2.5c0-.69.559-1.25 1.25-1.25"
    />
    <path
      fill="url(#carryOnBaggageNotIncluded_svg__e)"
      d="M11 26.872c.69 0 1.25.56 1.25 1.25h-2.5c0-.69.559-1.25 1.25-1.25"
    />
    <path
      fill="#868686"
      d="M17.876 3.569h-3.75v9.342h-1.25V3.57c0-.73.56-1.322 1.25-1.322h3.75c.69 0 1.25.592 1.25 1.322v9.342h-1.25V3.57Z"
    />
    <foreignObject width={17.447} height={19.959} x={7.273} y={9.163}>
      <div
        style={{
          backdropFilter: "blur(.5px)",
          clipPath: "url(#carryOnBaggageNotIncluded_svg__f)",
          height: "100%",
          width: "100%",
        }}
      />
    </foreignObject>
    <path
      fill="url(#carryOnBaggageNotIncluded_svg__g)"
      d="M21.723 10.163H10.271c-1.103 0-1.998.95-1.998 2.123V26c0 1.173.895 2.123 1.998 2.123h11.452c1.104 0 1.998-.95 1.998-2.123V12.286c0-1.172-.895-2.123-1.998-2.123"
    />
    <path
      fill="#fff"
      d="M13.97 13.226c-.173 0-.313.151-.313.338V25.6c0 .187.14.338.312.338.173 0 .313-.151.313-.338V13.564c0-.187-.14-.338-.313-.338Zm2.032 0c-.172 0-.312.151-.312.338V25.6c0 .187.14.338.312.338.173 0 .313-.151.313-.338V13.564c0-.187-.14-.338-.313-.338m2.03 0c-.172 0-.312.151-.312.338V25.6c0 .187.14.338.312.338.173 0 .313-.151.313-.338V13.564c0-.187-.14-.338-.313-.338"
      opacity={0.4}
    />
    <path
      fill="url(#carryOnBaggageNotIncluded_svg__h)"
      d="M16.171 18.989s-.17-.513-.348-.673l-.757-2.012.768-.289s.179-.164.33-.215.314-.027.314-.027l1.253-.472.297-.202.303-.024.773-.392.108.025c.06.187.3.881.3.881l.731 1.942-.502.275-.262.15-.375.09-.755.323s-.155-.044-.322.026-.313.213-.313.213l-1.246.469c-.12-.05-.297-.088-.297-.088"
    />
    <path
      fill="#272727"
      d="M19.122 3.497h-6.25c0-.691.559-1.25 1.25-1.25h3.75c.69 0 1.25.559 1.25 1.25"
      opacity={0.4}
    />
    <rect
      width={4.6}
      height={29.85}
      x={24.5}
      y={5.8}
      fill="#fff"
      rx={2.3}
      transform="rotate(45 24.5 5.8)"
    />
    <rect
      width={2}
      height={29.85}
      x={26.57}
      y={7.4}
      fill="#DE370C"
      rx={1}
      transform="rotate(45 26.57 7.4)"
    />
  </svg>
);
export default SvgCarryOnBaggageNotIncluded;
